import { channels } from "@/mocks/freegua";

export default function Channels() {
  return (
    <section id="channels" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="font-label text-sm font-bold tracking-widest text-accent-600">免费吃瓜题材分区</span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            想围观哪一类，这里都有整理好的瓜
          </h2>
          <p className="mt-4 text-base text-foreground-600">
            每个题材的素材都按截图、时间线、后续回应归好类，点进去零元直接看。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((c) => (
            <a
              key={c.name}
              href="#topics"
              className="hover-lift group flex items-center gap-4 rounded-2xl border border-background-200/80 bg-background-50 p-5"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${c.icon} text-xl`} aria-hidden="true" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="whitespace-nowrap text-base font-extrabold text-foreground-950 group-hover:text-primary-700">
                    {c.name}
                  </h3>
                  <span className="whitespace-nowrap text-xs font-bold text-accent-600">{c.count}</span>
                </div>
                <p className="mt-1 line-clamp-1 text-sm text-foreground-600">{c.desc}</p>
              </div>
              <i className="ri-arrow-right-line shrink-0 text-background-300 transition-colors group-hover:text-primary-500" aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}